import { render, staticRenderFns } from "./Scale_factor_answer.vue?vue&type=template&id=7897bd1e"
import script from "./Scale_factor_answer.vue?vue&type=script&lang=js"
export * from "./Scale_factor_answer.vue?vue&type=script&lang=js"
import style0 from "./Scale_factor_answer.vue?vue&type=style&index=0&id=7897bd1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports